export const API_IP = 'http://localhost';

const API_ADDRESS = `${window.location.protocol}://${window.location.host}/api`;

export const environment = {
  production: true,
  cloud: false,
  gatewayUrl: `${API_ADDRESS}/graphql`,
  notificationUrl: `${API_ADDRESS}/graphql`,
  appInsights: {
    instrumentationKey: '352e187c-68e9-4a0a-b405-4723939205b8'
  }
};
